import { useState } from 'react';

interface Props {
  onFinish: () => void;
}

// 全家等通路需店員看此畫面人工核實,故不自動結束,等使用者按「下一步」才 fade-out + onFinish
const ReturnCompleteAnimation = ({ onFinish }: Props) => {
  const [fadingOut, setFadingOut] = useState(false);

  const handleNext = () => {
    if (fadingOut) return;
    setFadingOut(true);
    setTimeout(onFinish, 400);
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: '#3db270',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 24,
        opacity: fadingOut ? 0 : 1,
        transition: 'opacity 0.4s ease-out',
        animation: fadingOut ? undefined : 'returnCompleteFadeIn 0.25s ease-out',
      }}
    >
      <style>{`
        @keyframes returnCompleteFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes returnCompleteCheckDraw {
          0%   { stroke-dashoffset: 48; transform: scale(0.6); }
          60%  { stroke-dashoffset: 0;  transform: scale(1.08); }
          100% { stroke-dashoffset: 0;  transform: scale(1); }
        }
        @keyframes returnCompleteCircle {
          0%   { transform: scale(0); opacity: 0; }
          60%  { transform: scale(1.06); opacity: 1; }
          100% { transform: scale(1); opacity: 1; }
        }
        @keyframes returnCompleteTextUp {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <div
        style={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          background: '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
          animation: 'returnCompleteCircle 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both',
          transformOrigin: 'center',
        }}
      >
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
          <path
            d="M16 33 L28 45 L48 21"
            stroke="#3db270"
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="48"
            style={{
              animation: 'returnCompleteCheckDraw 0.55s 0.25s ease-out both',
              transformOrigin: 'center',
            }}
          />
        </svg>
      </div>

      <div
        style={{
          color: '#ffffff',
          fontSize: 28,
          fontWeight: 700,
          letterSpacing: 2,
          animation: 'returnCompleteTextUp 0.4s 0.6s ease-out both',
        }}
      >
        歸還完成
      </div>

      <div
        style={{
          color: 'rgba(255, 255, 255, 0.85)',
          fontSize: 14,
          fontWeight: 500,
          animation: 'returnCompleteTextUp 0.4s 0.8s ease-out both',
        }}
      >
        感謝使用 PackAge+ 循環包裝
      </div>

      <button
        type="button"
        onClick={handleNext}
        disabled={fadingOut}
        style={{
          marginTop: 8,
          width: 220,
          height: 46,
          background: '#ffffff',
          color: '#3db270',
          border: 'none',
          borderRadius: 6,
          fontSize: 17,
          fontWeight: 700,
          boxShadow: '6px 8px 0px rgba(0, 0, 0, 0.16)',
          cursor: fadingOut ? 'default' : 'pointer',
          animation: 'returnCompleteTextUp 0.4s 1.1s ease-out both',
        }}
      >
        下一步
      </button>
    </div>
  );
};

export default ReturnCompleteAnimation;
